// getCreditCards returns a list of credit card (object)
// for the given creditCards state.
const getCreditCards = ({ ids = [], data = {} }) => ids.map(id => data[id]);

export { getCreditCards };
